<template>
  <router-link v-slot="{ isActive, href, navigate }" :to="link.route ?? ''" custom>
    <a
      v-bind="$attrs"
      :href="href"
      class="flex h-[50px] w-full min-w-[40px] justify-center items-center text-[--color-body-text] hover:text-[--color-primary-500]"
      :class="{ 'text-[--color-primary-500]': isActive }"
      :aria-label="ariaLabel"
      @click="navigate"
    >
      <span class="relative">
        <slot name="icon">
          <VcIcon v-if="link.icon" :name="link.icon" :size="24" />
        </slot>

        <transition mode="out-in" name="scale">
          <!-- Innovadis custom: add max-content to give badge some horizontal padding -->
          <VcBadge
            v-if="count"
            class="absolute left-4 -top-2 transition-transform bg-[--color-berry] border-[--color-berry] font-normal"
            variant="solid"
            rounded
            max-width="max-content"
          >
            {{ $n(count, { style: "decimal", notation: "compact" }) }}
          </VcBadge>
        </transition>
      </span>

      <span>
        <slot />
      </span>
    </a>
  </router-link>
</template>

<script setup lang="ts">
import type { ExtendedMenuLinkType } from "@/core/types";

interface IProps {
  link: ExtendedMenuLinkType;
  ariaLabel?: string;
  count?: number;
}

defineOptions({
  inheritAttrs: false,
});

withDefaults(defineProps<IProps>(), {
  count: 0,
});
</script>
